export default {
  positive: 'Positivo',
  neutral: 'Neutro',
  negative: 'Negativo',
  notClassified: 'No Clasificado',
  showAllThemes: 'Todos los temas',
};
